import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "../../../Assets/assetsnew/frontend_logo_with_name.webp";

const NavWrapper = styled.nav`
  position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    z-index: 1000;
    background-color: var(--bgColorFrontend);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 10px;
`;

const NavInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 18.4px 14px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LogoImage = styled.img`
  width: 200px; 
  height: auto;
  display: block;

  @media (max-width: 500px) {
    width: 175px; 
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: inline-block;
  padding: 8px 12px;
  border-radius: 8px;
  background-color:var(--brandColor);
  color: var(--white);
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  
  @media (max-width: 576px) {
    font-size: 14px;
 }
`;

const Navbar = () => {
  return (
    <NavWrapper>
      <NavInner>
        <LogoImage
          src={logo}
          alt="Logo"
        />

        <StyledLink
          to="/db/signup"
        >
          Try for Free
        </StyledLink>
      </NavInner>
    </NavWrapper>
  );
};

export default Navbar;